import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconPresentationChartLine = ({
  title = "presentation chart line",
  color = "black",
  viewBoxWidth = 24,
  viewBoxHeight = 24,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon
    {...{
      title,
      viewBoxHeight,
      viewBoxWidth,
      strokeWidth: "2",
      stroke: uiColorToBaseColor(color),
      fill: "none",
      ...otherProps,
    }}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
    />
  </Svg.Icon>
)

export default IconPresentationChartLine
